<template>
  <b-input-group>
    <b-input-group-prepend is-text>
      <LucideIcon
        name="search"
        :size="16"
      />
    </b-input-group-prepend>
    <b-input
      v-model="query"
      type="search"
      placeholder="Search"
      @input="search"
    />
  </b-input-group>
</template>

<script>
import LucideIcon from './LucideIcon.vue'

export default {
  name: 'InputSearch',

  components: {
    LucideIcon,
  },

  data: () => ({
    query: '',
  }),

  methods: {
    search: _.throttle(function () {
      const payload = { search: this.query || null }
      this.$emit('search', payload)
    }, 300),
  },
}
</script>

<style scoped lang="scss">
@import "@/../sass/frontend/variables";

.input-group {
  border-radius: 6px;

  &:focus-within {
    box-shadow: 0 0 0 3px rgba($primary200, 0.15);
  }

  &:focus-within ::v-deep .input-group-text,
  &:focus-within ::v-deep .form-control {
    border-color: $primary200;
  }
}

::v-deep .input-group-text {
  height: 40px;
  padding-right: 4px;
  border: 1px solid $greyscale100;
  border-right: 0;
  border-radius: 6px 0 0 6px;
  background-color: #fff;
  color: #64748b;
}

::v-deep .form-control {
  height: 40px;
  padding-left: 4px;
  border: 1px solid $greyscale100;
  border-left: 0;
  border-radius: 0 6px 6px 0;
  color: $greyscale400;
  font-size: 14px;

  &::placeholder {
    color: #64748b;
  }

  // Chrome paints its own blue cross for `type="search"`, off-palette and not in the design.
  &::-webkit-search-cancel-button {
    display: none;
  }

  &:focus {
    box-shadow: none;
  }
}
</style>
